<template>
  <div class="wage-total">
    <div class="wage-head">
      <el-date-picker
        v-model="search.year"
        type="year"
        @change="changeYear"
        value-format="yyyy"
        placeholder="选择年">
      </el-date-picker>
      <span style="margin-left:2vw;">所属企业：</span>
      <el-select v-model="search.entId" filterable @change="doFilter" placeholder="请选择">
        <el-option
          v-for="item in entList"
          :key="item.emtId"
          :label="item.entName"
          :value="item.emtId">
        </el-option>
      </el-select>
    </div>
    <div class="wage-con">
      <div id="wageChat" style="max-width:90%;height:99%;"></div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
  data(){
    return {
      search:{
        year:util.myTime.formatTime(new Date(),'yyyy'),
        entId:'',
      },
      groupId:'',
      entList:[],//所属企业
      months:[],
    }
  },
  mounted(){
    this.groupId = util.session.get('groupId')
    this.getJoinEnt()
    this.defaultFun()
  },
  methods:{
    //获取参建单位
    getJoinEnt(){
      var that = this
      myHttp.getProjectEntByProjectId({
          projectId:this.groupId
      }).then(function(resp){
        if (resp.data.code == '200'){
          var list = resp.data.data.projectEnt || []
          that.entList = list
          if(that.search.entId==''){
            that.search.entId = list[0].emtId
          }
          that.getData()
        }
      })
    },
    //监听
    doFilter(){
      // this.changeYear()
      this.getData()
    },
    //获取信息
    getData(){
      var that = this
      myHttp.selectSalaryInfoByYear({
        projectId:this.groupId,
        year:this.search.year,
        entId:this.search.entId
      }).then(function(resp){
        if(resp.data.code=='200'){
          console.log(resp)
          var list = resp.data.data.entity||[]
          var result = []
          var teams = []
          for(var i=0;i<list.length;i++){
            teams.push(list[i].teamsName)
            var obj = {
              name:list[i].teamsName,
              type:'line',
              data:[],
              smooth: true
            }
            if(list[i].salaryList && list[i].salaryList.length>0){
              for(var j=0;j<list[i].salaryList.length;j++){
                obj.data.push(list[i].salaryList[j].salary)
              }
            }else{
              for(var k=0;k<12;k++){
                obj.data.push(0)
              }
            }
            result.push(obj)
          }
          console.log(result)
          that.defaultFun(teams,result)
        }
      })
    },
    //监听年份
    changeYear(){
      var year = this.search.year
      this.months = []
      for(var i=0;i<12;i++){
        var str = i<9?year+'-0'+(i+1):year+'-'+(i+1)
        this.months.push(str)
      }
      this.getData()
    },
    //月份
    getMonth(){
      if(this.months.length==0){
        var year = this.search.year
        this.months = []
        for(var i=0;i<12;i++){
          var str = i<9?year+'-0'+(i+1):year+'-'+(i+1)
          this.months.push(str)
        }
      }
    },
    //展示
    defaultFun(x,data){
      // console.log(this.months)
      this.getMonth()
      var option = {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: x
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          data: this.months
          // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: data,
        
        // [
        //   {
        //     name: 'Email',
        //     type: 'line',
        //     stack: 'Total',
        //     data: [120, 132, 101, 134, 90, 230, 210]
        //   },
        //   {
        //     name: 'Union Ads',
        //     type: 'line',
        //     stack: 'Total',
        //     data: [220, 182, 191, 234, 290, 330, 310]
        //   },
        //   {
        //     name: 'Video Ads',
        //     type: 'line',
        //     stack: 'Total',
        //     data: [150, 232, 201, 154, 190, 330, 410]
        //   },
        //   {
        //     name: 'Direct',
        //     type: 'line',
        //     stack: 'Total',
        //     data: [320, 332, 301, 334, 390, 330, 320]
        //   },
        //   {
        //     name: 'Search Engine',
        //     type: 'line',
        //     stack: 'Total',
        //     data: [820, 932, 901, 934, 1290, 1330, 1320]
        //   }
        // ]
      }
      var myChart = this.$echarts.init(document.getElementById('wageChat'))
      myChart.clear();
      myChart.setOption(option)
    },
  }
}
</script>

<style scoped>
  .wage-total{
    width: 100%;
    height: 100%;
    position: relative;
    background: #fff;
  }
  .wage-head{
    width: 100%;
    height: 6vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 0 1vw;
    border-bottom: 1px solid #409EFF;
  }
  .wage-con{
    width: 100%;
    height: calc( 100% - 6vh );
    position: relative;
  }
</style>

<style>
  @import '../../../assets/css/common.css';

</style>